import { gql } from '@apollo/client'

import { BILLING_DETAILS_FRAGMENT } from './BillingDetailsFragment'
import { CARD_FRAGMENT } from './CardFragment'

export const PAYMENT_METHOD_FRAGMENT = gql`
  fragment PaymentMethod on PaymentMethod {
    card {
      ...Card
    }
    usingLink
    billingDetails {
      ...BillingDetails
    }
  }
  ${CARD_FRAGMENT}
  ${BILLING_DETAILS_FRAGMENT}
`

export default PAYMENT_METHOD_FRAGMENT
